const NOTEBOOK_BASE_ROUTE = '/notebook';

export const NOTEBOOK_API_ROUTES = {
  index: () => NOTEBOOK_BASE_ROUTE,
  notebookInfo: (notebookId: string) => `${NOTEBOOK_BASE_ROUTE}/${notebookId}`,
  list: () => `${NOTEBOOK_BASE_ROUTE}/list`,
} as const;
